import React from "react";
import { Header } from "../components/Header";
import { SectionFeatures } from "../components/SectionFeatures";
import { GlobalStyles } from "../components/ui/GlobalStyles";
import { SectionPrice } from "../components/SectionPrice";
import { SectionContact } from "../components/SectionContact";
import { SectionFooter } from "../components/SectionFooter";
import { Helmet } from "react-helmet";
import { ThemeProvider } from "styled-components";
import { theme } from "../lib/constant";

const Index = () => {
  return (
    <>
      <Helmet>
        <html lang="fr" />
        <title>
          Street Funders, l'application de récolte de dons face-to-face.
        </title>
        <meta
          name="keywords"
          content="Street Funders, Solution, Gestion, Récolte, Dons, ONG"
        />
        <meta
          name="description"
          content="Facile, rapide et intuitive. Simplifiez et optimisez la récolte de dons en face à face à l’aide d’une plateforme innovante adaptée à tout type d’ONG."
        />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, user-scalable=no"
        ></meta>
        <meta name="application-name" content="Street Funders" />
        <meta name="author" content="Igloo" />
      </Helmet>

      <GlobalStyles />

      <ThemeProvider theme={theme}>
        <Header />
        <SectionFeatures
          items={[
            {
              label: (
                <div>
                  <span style={{ marginRight: 20 }}>01.</span>
                  <span>Personnalisation</span>
                </div>
              ),
              desc:
                "Une application à vos couleurs. Des photos pour illustrer vos campagnes et fournir un support visuel à vos donateurs.",
              imageUrl: require("../../assets/screens/pers.jpg"),
            },
            {
              label: (
                <div>
                  <span style={{ marginRight: 20 }}>02.</span>
                  <span>Tout type de dons</span>
                </div>
              ),
              desc:
                "One-off ou récurrent. Mensuel, trimestriel, semestriel ou annuel. Personnalisez chacune de vos campagnes et proposez les bons montants pour chaque cause. De plus, nous calculons la déduction fiscale et le coût réel du don.",
              imageUrl: require("../../assets/screens/dons.jpg"),
            },
            {
              label: (
                <div>
                  <span style={{ marginRight: 20 }}>03.</span>
                  <span>Incomplets</span>
                </div>
              ),
              desc:
                "Gestion intuitive des donnateurs incomplets avec suivi des rendez-vous et requalification intelligente via plusieurs sources (recruteur, coordinateur ou centrale). Le montant et la date du 1er prélèvement sont même adaptables lors de la requalification.",
              imageUrl: require("../../assets/screens/incomplet.jpg"),
            },
            {
              label: (
                <div>
                  <span style={{ marginRight: 20 }}>04.</span>
                  <span>Saisie intelligente</span>
                </div>
              ),
              desc:
                "Complétion des adresses email, auto-suggestion des adresses postales, conversion automatique des numéros IBAN et auto-déduction du BIC, … Nous utilisons toute la force des services en ligne pour accélérer la saisie des données et limiter les erreurs.",
              imageUrl: require("../../assets/screens/saisie.jpg"),
            },
          ]}
        />

        <SectionPrice />

        <SectionContact />

        <SectionFooter />
      </ThemeProvider>
    </>
  );
};

export default Index;
